export default "__VITE_PUBLIC_ASSET__db696636__"